<!-- <div fxLayout="row">
    <div fxFlex="100">
        <div fxLayout="row" fxLayoutAlign="center">
            <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.sm="50" class="p-3">
                <div class="bordered px-3 py-2">
                    <div fxLayoutAlign="space-between center">
                        <mat-icon class="text-muted">perm_identity</mat-icon>
                    </div>
                    <h1 class="secondary-font text-center mb-3">Porte monaie electronique VALIDE</h1>
                    <div class="divider"></div>
                    <div class="pt-3">
                        <p>
                            Votre porte monaie electronique permet de vous transferer l'argent que vous avez gagnez sur notre platforme.
                            Cette procédure est simple et rapide.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <br /><br />
        <form [formGroup]="infoFormPorteMonaie" (ngSubmit)="onInfoFormPorteMonaieSubmit()" autocomplete="off" *ngIf="dataShow">
            
            <div fxLayout="row" fxLayoutAlign="center">
                <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>N° de telephone</mat-label>
                        <input matInput placeholder="EX: +221..." formControlName="phone_number" maxlength="13"
                            minlength="12">
                        <mat-error *ngIf="infoFormPorteMonaie.controls.phone_number.errors?.required">
                            Numéro de téléphone obligatoire
                        </mat-error>
                        <mat-error *ngIf="infoFormPorteMonaie.controls.phone_number.errors?.pattern">
                            Le format du numéro saisi n'est pas correct(+221|+33 774543412)
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="center">
                <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                    <mat-radio-group aria-label="Select an option" formControlName="operateur" required>
                        <mat-radio-button value="wave">
                            <app-image-paiement [key]="'wave'" ></app-image-paiement>
                    </mat-radio-button>&nbsp;&nbsp;
                        <mat-radio-button value="orange">
                            <app-image-paiement [key]="'orange'" ></app-image-paiement>
                        </mat-radio-button>
                      </mat-radio-group>
                      <mat-error *ngIf="infoFormPorteMonaie.controls.operateur.errors?.required">
                        NB: Choisir un operateur est obligatoire</mat-error>
                    
                </div>
            </div><br><br>
            <div fxLayout="row wrap" fxLayoutAlign="center">
                <div fxFlex="100" fxFlex.gt-sm="20" class="px-2" ngClass.sm="mt-1" ngClass.xs="mt-1">
                    <div class="text-center">
                        <button mat-raised-button color="primary" type="submit"> Mettre à jour</button>
                    </div>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="15" class="px-2" ngClass.sm="mt-1" ngClass.xs="mt-1">
                    <div class="text-center">
                        <button mat-raised-button color="warn" onclick="history.back();" type="button">Annuler</button>
                    </div>
                </div>
            </div>
            
        </form>
    </div>
</div> -->

<div fxLayout="row">
    <div fxFlex="100">
        <div fxLayout="row" fxLayoutAlign="center">
            <div fxFlex="100" fxFlex.gt-sm="50" fxFlex.sm="50" class="p-3">
                <div class="bordered px-3 py-2">
                    <div fxLayoutAlign="space-between center">
                        <mat-icon class="text-muted">perm_identity</mat-icon>
                    </div>
                    <h1 class="secondary-font text-center mb-3">Votre IBAN ou compte Paypal VALIDE</h1>
                    <div class="divider"></div>
                    <div class="pt-3">
                        <p>
                            Votre IBAN ou votre compte Paypal permet de vous transferer l'argent que vous avez gagnez sur notre platforme.
                            Cette procédure est simple et rapide.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <br /><br />

        <form>

            <div fxLayout="row" fxLayoutAlign="center">
                <div fxFlex="100" fxFlex.gt-sm="20" class="px-3"></div>
                <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                    <mat-radio-group aria-label="Select an option" formControlName="operateur" required>
                        <mat-radio-button value="iban">
                            <app-image-paiement [key]="'iban'" ></app-image-paiement>
                    </mat-radio-button>&nbsp;&nbsp;
                        <mat-radio-button value="paypal">
                            <app-image-paiement [key]="'paypal'" ></app-image-paiement>
                        </mat-radio-button>
                      </mat-radio-group>
                      <!-- <mat-error *ngIf="infoFormPorteMonaie.controls.operateur.errors?.required">
                        NB: Choisir un operateur est obligatoire</mat-error> -->
                </div>
            </div><br><br>

            <div fxLayout="row" fxLayoutAlign="center">
                <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>N° de telephone</mat-label>
                        <input matInput placeholder="EX: +221..." formControlName="phone_number" maxlength="13"
                            minlength="12">
                        <mat-error *ngIf="infoFormPorteMonaie.controls.phone_number.errors?.required">
                            Numéro de téléphone obligatoire
                        </mat-error>
                        <mat-error *ngIf="infoFormPorteMonaie.controls.phone_number.errors?.pattern">
                            Le format du numéro saisi n'est pas correct(+221|+33 774543412)
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>


            <div fxLayout="row wrap" fxLayoutAlign="center">
                <div fxFlex="100" fxFlex.gt-sm="20" class="px-2" ngClass.sm="mt-1" ngClass.xs="mt-1">
                    <div class="text-center">
                        <button mat-raised-button color="primary" type="submit"> Mettre à jour</button>
                    </div>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="15" class="px-2" ngClass.sm="mt-1" ngClass.xs="mt-1">
                    <div class="text-center">
                        <button mat-raised-button color="warn" onclick="history.back();" type="button">Annuler</button>
                    </div>
                </div>
            </div>

        </form>
    </div>
    